import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { ElementRef } from '@angular/core';

@Component({
    selector: 'zoom-new-contact-card',
    templateUrl: './new-contact-card.component.html',
    styleUrls: ['../contact-card/contact-card.component.scss', './new-contact-card.component.scss']
})
export class NewContactCardComponent {
    @ViewChild('nameInput') nameInput: ElementRef;
    @Input() isLoading: boolean;
    @Input() isPlugin = false;
    @Output() onAdd = new EventEmitter<any>();
    @Output() onClose = new EventEmitter<any>();
    public contact = {
        name: '',
        email: ''
    };

    constructor() {}

    ngAfterViewInit() {
        this.nameInput.nativeElement.focus();
    }

    handleAdd(contact: { name: string; email: string }) {
        const { name, email } = contact;
        this.onAdd.emit({ name, email });
    }

    handleClose() {
        this.onClose.emit();
    }
}
